<div class="d-flex flex-column export-parameter-root">
    <dx-toolbar *ngIf="!onlyUpdateFilter">
        <dxi-toolbar-item location="before">
            <div *dxTemplate>
                <div>
                    <dx-select-box
                        *ngIf="exportFormats.length > 0"
                        [dataSource]="exportFormats"
                        [itemTemplate]="myItemTemplate"
                        fieldTemplate="field"
                        [(value)]="config.format"
                        label="{{ 'Export Format' | translate }}"
                        (onValueChanged)="setExportVersions()"
                        class="npLabelExportDialog"
                        valueExpr="text">
                        <div *dxTemplate="let data of 'item'">
                            <span [class]="data.disabled ? 'my-another-class' : ''">{{ data?.text | translate }}</span>
                            <np-license-upgrade-button
                                *ngIf="data?.disabled"
                                class="float-end"
                                [additionalInfo]="getExportFormatInfoText(data.text)"
                            ></np-license-upgrade-button>
                        </div>
                        <div *dxTemplate="let data of 'field'">
                            <dx-text-box [readOnly]="true" value="{{ data?.text | translate }}"></dx-text-box>
                        </div>
                    </dx-select-box>
                </div>
            </div>
        </dxi-toolbar-item>
        <dxi-toolbar-item location="before">
            <div *dxTemplate>
                <div>
                    <dx-select-box
                        *ngIf="exportVersions.length > 0"
                        [dataSource]="exportVersions"
                        fieldTemplate="field"
                        [itemTemplate]="myItemTemplate"
                        [(value)]="config.version"
                        label="{{ 'Export Version' | translate }}"
                        (onValueChanged)="onVersionChange($event)"
                        valueExpr="text">
                        <div *dxTemplate="let data of 'item'">
                            <span [class]="data.disabled ? 'my-another-class' : ''">{{ data?.text | translate }}</span>
                            <np-license-upgrade-button *ngIf="data?.disabled" class="float-end"></np-license-upgrade-button>
                        </div>
                        <div *dxTemplate="let data of 'field'">
                            <dx-text-box [readOnly]="true" value="{{ data?.text | translate }}"></dx-text-box>
                        </div>
                    </dx-select-box>
                    <dx-select-box
                        *ngIf="exportToCustomers.length > 0"
                        [dataSource]="exportToCustomers"
                        fieldTemplate="field"
                        displayExpr="name"
                        valueExpr="id"
                        [(value)]="config.version"
                        label="{{ 'Export To Customer' | translate }}">
                        <div *dxTemplate="let data of 'field'">
                            <dx-text-box [readOnly]="true" value="{{ data.name }}"></dx-text-box>
                        </div>
                    </dx-select-box>
                </div>
            </div>
        </dxi-toolbar-item>
        <dxi-toolbar-item location="before">
            <div class="d-flex flex-row align-items-center">
                <div id="useFeatureOrderSwitch"
                     class="flex-grow-1"
                     *ngIf="(config.format == 'FIELDLIST' || config.version == 'FIELDLIST')">
                    {{ 'Features nach Order' | translate }}
                </div>
                <div>
                    <dx-switch [(value)]="config.useFeatureOrder"
                               *ngIf="(config.format == 'FIELDLIST' || config.version == 'FIELDLIST')"/>
                    <dx-tooltip
                        target="#useFeatureOrderSwitch"
                        showEvent="mouseenter"
                        hideEvent="mouseleave"
                        [hideOnOutsideClick]="false">
                        <div *dxTemplate="let data = data; of: 'content'">
                            {{ 'Hier können Sie einstellen, ob die Features nach Order oder nach Namen ausgegeben werden' | translate }}
                        </div>
                    </dx-tooltip>
                </div>
            </div>
        </dxi-toolbar-item>

        <dxi-toolbar-item location="after">
            <ng-content select="[header]"></ng-content>
        </dxi-toolbar-item>
    </dx-toolbar>

    <dx-tab-panel #exportTabPanel
                  class="flex-grow-1 export-tab-panel"
                  [(selectedIndex)]="selectedIndex"
                  (onContentReady)="ensureSelectedTabIsVisibleFromTabPanel()"
                  (onOptionChanged)="onTabPanelOptionChanged($event)">
        <dxi-tab-panel-item [visible]="isConfigurationTabVisible" title="{{ 'Konfiguration' | translate }}">
            <div *dxTemplate>
                <dx-scroll-view showScrollbar="always" height="inherit">
                    <exportConfiguration
                        [popupOpen]="popupOpen"
                        [exportParameter]="config"
                        class="full-size-inline-block"></exportConfiguration>
                </dx-scroll-view>
            </div>
        </dxi-tab-panel-item>

        <dxi-tab-panel-item [visible]="isFilterTabVisible"
                            title="{{ 'Filter auswählen' | translate }}">
            <div *dxTemplate>
                <dx-tab-panel [repaintChangesOnly]="true"
                              [(selectedIndex)]="filterIndex"
                              class="h-inherit">
                    <dxi-tab-panel-item title="{{ 'Filter Einstellungen' | translate }}">
                        <div *dxTemplate>
                            <np-filter-config [(exportParameter)]="config"
                                              class="full-size-inline-block"></np-filter-config>
                        </div>
                    </dxi-tab-panel-item>
                    <dxi-tab-panel-item title="{{ 'Produktstatus filtern' | translate }}">
                        <div *dxTemplate>
                            <productStateFilter [exportParameter]="config"
                                                [catalogId]="catalogId"
                                                [customerId]="customerId"
                                                class="full-size-inline-block"></productStateFilter>
                        </div>
                    </dxi-tab-panel-item>
                    <dxi-tab-panel-item title="{{ 'Kategorien filtern' | translate }}">
                        <div *dxTemplate>
                            <categoryFilter [exportParameter]="config"
                                            [catalogId]="catalogId"
                                            [customerId]="customerId"
                                            class="full-size-inline-block"></categoryFilter>
                        </div>
                    </dxi-tab-panel-item>
                    <dxi-tab-panel-item title="{{ 'Hersteller' | translate }}">
                        <div *dxTemplate>
                            <manufacturerFilter [exportParameter]="config"
                                                [catalogId]="catalogId"
                                                [customerId]="customerId"
                                                class="full-size-inline-block"></manufacturerFilter>
                        </div>
                    </dxi-tab-panel-item>
                    <dxi-tab-panel-item title="{{ 'Lieferant' | translate }}">
                        <div *dxTemplate>
                            <supplierContentFilter [exportParameter]="config"
                                                   [catalogId]="catalogId"
                                                   [customerId]="customerId"
                                                   class="full-size-inline-block"></supplierContentFilter>
                        </div>
                    </dxi-tab-panel-item>
                    <dxi-tab-panel-item [visible]="loginService.hasAddonUDX" title="{{ 'Udx filtern' | translate }}">
                        <div *dxTemplate>
                            <udxFilter [exportParameter]="config"
                                       [catalogId]="catalogId"
                                       [customerId]="customerId"
                                       class="full-size-inline-block"></udxFilter>
                        </div>
                    </dxi-tab-panel-item>
                    <dxi-tab-panel-item title="{{ 'Datum' | translate }}">
                        <div *dxTemplate>
                            <dateFilter [exportParameter]="config"
                                        class="full-size-inline-block"></dateFilter>
                        </div>
                    </dxi-tab-panel-item>
                    <dxi-tab-panel-item title="{{ 'Liste' | translate }}">
                        <div *dxTemplate>
                            <searchByListFilter [exportParameter]="config"
                                                class="full-size-inline-block"></searchByListFilter>
                        </div>
                    </dxi-tab-panel-item>
                    <dxi-tab-panel-item title="{{ 'Medien' | translate }}">
                        <div *dxTemplate>
                            <mime-filter [exportParameter]="config"
                                         [catalogId]="catalogId"
                                         [customerId]="customerId"
                                         class="full-size-inline-block">
                            </mime-filter>
                        </div>
                    </dxi-tab-panel-item>
                </dx-tab-panel>
            </div>
        </dxi-tab-panel-item>

        <dxi-tab-panel-item [visible]="isContentTabVisible"
                            title="{{ 'Inhalte auswählen' | translate }}">
            <div *dxTemplate>
                <dx-tab-panel [(selectedIndex)]="contentIndex"
                              class="h-inherit">
                    <dxi-tab-panel-item title="{{ 'Features auswählen' | translate }}">
                        <div *dxTemplate>
                            <featureContentFilter [exportParameter]="config"
                                                  [catalogId]="catalogId"
                                                  [customerId]="customerId"
                                                  class="full-size-inline-block"></featureContentFilter>
                        </div>
                    </dxi-tab-panel-item>
                    <dxi-tab-panel-item title="{{ 'Preislisten auswählen' | translate }}">
                        <div *dxTemplate>
                            <pricelistContentFilter [exportParameter]="config"
                                                    [catalogId]="catalogId"
                                                    [customerId]="customerId"
                                                    class="full-size-inline-block"></pricelistContentFilter>
                        </div>
                    </dxi-tab-panel-item>
                    <dxi-tab-panel-item [visible]="loginService.hasAddonUDX"
                                        title="{{ 'Udx auswählen' | translate }}">
                        <div *dxTemplate>
                            <udxContentFilter [exportParameter]="config"
                                              [catalogId]="catalogId"
                                              [customerId]="customerId"
                                              class="full-size-inline-block"></udxContentFilter>
                        </div>
                    </dxi-tab-panel-item>
                    <dxi-tab-panel-item title="{{ 'Medien auswählen' | translate }}">
                        <div *dxTemplate>
                            <mime-content-filter [exportParameter]="config"
                                                 [catalogId]="catalogId"
                                                 [customerId]="customerId"
                                                 class="full-size-inline-block">
                            </mime-content-filter>
                        </div>
                    </dxi-tab-panel-item>
                    <dxi-tab-panel-item title="{{ 'Kategorie' | translate }}">
                        <div *dxTemplate>
                            <div class="category-tab-container">
                                <div class="dx-fieldset dx-fieldset-export-margin">
                                    <div class="dx-field">
                                        <div class="dx-field-label">{{ 'Nur gefilterte Kategorien an Produkte schreiben' | translate }}</div>
                                        <div class="dx-field-value">
                                            <dx-switch [(value)]=config.exportOnlyFilteredGroupStrings></dx-switch>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </dxi-tab-panel-item>
                </dx-tab-panel>
            </div>
        </dxi-tab-panel-item>

        <dxi-tab-panel-item [visible]="isExcelTemplateTabVisible" title="{{ 'Excel Template' | translate }}">
            <div *dxTemplate>
                <dx-scroll-view showScrollbar="always" height="inherit">
                    <template-editor
                        class="w-100 h-100"
                        [exportVersion]="config.version"
                        [showSelector]="true"
                        [exportMode]="true"
                        [templateChange]="onTemplateChange.asObservable()"
                    ></template-editor>
                </dx-scroll-view>
            </div>
        </dxi-tab-panel-item>

        <dxi-tab-panel-item [visible]="isFieldListTabVisible" title="{{ 'Excel Fields' | translate }}">
            <div *dxTemplate>
                <fieldList
                    [fields]="catalogService.fields"
                    [fieldGroups]="fieldGroups"
                    [fieldListContainer]="config"
                    class="h-inherit"
                ></fieldList>
            </div>
        </dxi-tab-panel-item>

        <dxi-tab-panel-item [visible]="isMappingTabVisible" title="{{ 'Mapping' | translate }}">
            <div *dxTemplate>
                <wawiMappingChooser
                    [fields]="wawiMappingFields"
                    [fieldGroups]="fieldGroups"
                    [exportParameter]="config"
                    [exportMode]="true"
                    class="h-inherit"
                ></wawiMappingChooser>
            </div>
        </dxi-tab-panel-item>

        <dxi-tab-panel-item [visible]="isCsvSettingsTabVisible" title="{{ 'CSV Einstellungen' | translate }}">
            <div *dxTemplate>
                <csvSettings [exportParameter]="config" class="h-inherit"></csvSettings>
            </div>
        </dxi-tab-panel-item>

        <dxi-tab-panel-item [visible]="isInterfaceSettingsTabVisible" title="{{ 'Schnittstellen Einstellung' | translate }}">
            <div *dxTemplate class="interface-settings-template">
                <np-interface-setting [exportParameter]="config" class="h-inherit"></np-interface-setting>
            </div>
        </dxi-tab-panel-item>
    </dx-tab-panel>

    <div class="export-footer">
        <dx-toolbar>
            <dxi-toolbar-item class="toolbar-item-mt-10">
                <div class="d-flex flex-column">
                    <div class="{{ getClass() }}">{{ getConfigSummary() }}</div>
                    <div class="d-flex flex-row footer-actions">
                        <ng-content></ng-content>
                    </div>
                </div>
            </dxi-toolbar-item>
            <dxi-toolbar-item location="after" *ngIf="!schedulerDisabled">
                <div *dxTemplate>
                    <dx-date-box
                        [(value)]="config.scheduledFor"
                        width="auto"
                        type="datetime"
                        label="{{ 'Export Startzeit' | translate }}"
                    ></dx-date-box>
                </div>
            </dxi-toolbar-item>
        </dx-toolbar>
    </div>
</div>
